import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { createElement } from 'react';
import CSSTransition from 'react-transition-group/Transition';

var Transition = function Transition(_ref) {
  var styles = _ref.styles,
      inProp = _ref["in"],
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 200 : _ref$timeout,
      _ref$transition = _ref.transition,
      transition = _ref$transition === void 0 ? "all " + timeout + "ms cubic-bezier(0.23, 1, 0.32, 1)" : _ref$transition,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["styles", "in", "timeout", "transition", "children"]);

  var computedStyle = function computedStyle(state) {
    return _extends({}, styles.init, {
      transition: transition
    }, styles[state]);
  };

  return /* @__PURE__ */createElement(CSSTransition, _extends({
    appear: true,
    unmountOnExit: true,
    "in": inProp,
    timeout: timeout
  }, rest), function (state) {
    return children(computedStyle(state));
  });
};

export { Transition };
//# sourceMappingURL=base.esm.js.map
